import { useEffect, RefObject } from 'react';

/**
 * Saves/restores scroll position for a scrollable container using sessionStorage.
 * Saves on unmount; restores on mount via requestAnimationFrame to avoid flicker.
 */
export function useScrollRestore(ref: RefObject<HTMLElement | null>, key: string): void {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Restore scroll position after paint
    const stored = sessionStorage.getItem(`scroll:${key}`);
    if (stored) {
      const scrollTop = parseInt(stored, 10);
      if (!isNaN(scrollTop)) {
        requestAnimationFrame(() => {
          if (ref.current) {
            ref.current.scrollTop = scrollTop;
          }
        });
      }
    }

    // Save scroll position on unmount
    return () => {
      if (ref.current) {
        sessionStorage.setItem(`scroll:${key}`, String(ref.current.scrollTop));
      }
    };
  }, [key]);
}
